import templateStr from 'text!./mobileLobCoverages.html';

function controller() {}

export default {
    template: templateStr,
    bindings: {
        coverages: '<',
        schedules: '<',
        branchCode: '<',
        lobCode: '@',
        offeringId: '<'
    },
    controller: controller
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/quoteandbind/directives/LobOfferingSelection/mobileQuoteView/mobileLobCoverages/mobileLobCoverages.js
// module id = 1220
// module chunks = 0